import { collection, getDocs, query, Timestamp, where } from "firebase/firestore";
import { db } from "../firebase/config";
import { useLoaderData } from "react-router-dom";
import ExportTableAsCSV from "../components/ExportTableAsCSV";

function Puma2026AprilCampaignRequests() {
  const usersList = [];
  const result = useLoaderData(puma2026AprilCampaignLoader);

  result.forEach((doc) => {
    usersList.push({ id: doc.id, ...doc.data() });
    usersList.sort((a, b) => b.date - a.date);
  });

  return (
    <div className="container py-8 mx-auto">
      <ExportTableAsCSV
        tableData={document.querySelector(".pumaGetInTouchTable")}
        fileName="Puma_April_2026_Campaign_Requests.csv"
      />
      <div className="grid grid-cols-6 gap-0 p-2 text-white bg-fordBlue pumaGetInTouchTable">
        <h4 className="col-span-1">Име</h4>
        <h4 className="col-span-1 text-center">Имейл</h4>
        <h4 className="col-span-1 text-center">Телефон</h4>
        <h4 className="text-center">Град</h4>
        <h4 className="text-center">Запитване</h4>
        <h4 className="text-center ">Дата</h4>
      </div>
      {usersList &&
        usersList.map((user) => (
          <div
            className="grid grid-cols-6 gap-2 p-2 border-b text-fordBlue even:bg-gray-50 hover:bg-gray-200 offerTableRow"
            key={user.id}
          >
            <p className="col-span-1">{user.name}</p>
            <p className="col-span-1 text-center">{user.email}</p>
            <p className="col-span-1 text-center">{user.phone}</p>
            <p className="text-center ">{user.dealership}</p>
            <p className="text-center ">{user.text}</p>
            <p className="text-center ">
              {user.date.toDate().toLocaleDateString("bg-BG")}
            </p>
          </div>
        ))}
    </div>
  );
}

export default Puma2026AprilCampaignRequests;

export const puma2026AprilCampaignLoader = async () => {
  const startOf2026 = Timestamp.fromDate(new Date(2026, 0, 1));
  const startOf2027 = Timestamp.fromDate(new Date(2027, 0, 1));

  const querySnapshot = await getDocs(
    query(
      collection(db, "Puma 2025GetInTouch"),
      where("date", ">=", startOf2026),
      where("date", "<", startOf2027),
    ),
  );

  return querySnapshot;
};
